import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=a21bbff6&scoped=true&"
import script from "./Audio.vue?vue&type=script&lang=js&"
export * from "./Audio.vue?vue&type=script&lang=js&"
import style0 from "./Audio.vue?vue&type=style&index=0&id=a21bbff6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21bbff6",
  null
  
)

export default component.exports